import { buildWhatsAppUrl, COMPANY } from "../../lib/constants";
import { WhatsAppIcon } from "./Header";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={buildWhatsAppUrl()}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Per WhatsApp kontaktieren"
      className="fixed bottom-6 right-6 md:right-auto md:left-6 z-50 group"
    >
      <div className="flex items-center gap-3 md:flex-row-reverse">
        <div className="hidden sm:flex flex-col items-end md:items-start bg-white rounded-full px-4 py-2 border border-black/10 group-hover:-translate-x-1 md:group-hover:translate-x-1 transition-transform shadow-[0_10px_30px_-10px_rgba(0,0,0,0.2)]">
          <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-black/60">
            Chat starten
          </span>
          <span className="text-xs font-semibold text-black">{COMPANY.phone}</span>
        </div>
        <div className="wa-pulse w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] flex items-center justify-center text-black shadow-[0_10px_40px_rgba(37,211,102,0.4)]">
          <WhatsAppIcon className="w-6 h-6 md:w-7 md:h-7" />
        </div>
      </div>
    </a>
  );
};
